import { useRef } from 'react';

import { useForm } from '@givebacks/formy';

import { Card } from '../../../../DataDisplay/Card/Card';
import { Checkbox } from '../../../../Inputs';
import { Group } from '../../../../Layout/Group';
import { Stack } from '../../../../Layout/Stack';
import { Text } from '../../../../Typography/Text/Text';
import classes from './AnonymousDonationForm.module.css';

export type AnonymousDonationFormType = {
  anonymous: boolean;
};

type AnonymousDonationFormProps = {
  useFormListValidator?: never;
  isAnonymous?: boolean;
  storeName?: string;
};

const AnonymousDonationForm = ({ isAnonymous = false, storeName }: AnonymousDonationFormProps) => {
  const isAnonymousRef = useRef(isAnonymous);
  const form = useForm<AnonymousDonationFormType>(
    {
      initialValues: {
        anonymous: isAnonymousRef.current,
      },
    },
    {
      id: 'anonymous',
    }
  );

  return (
    <Card withBorder radius="sm" className={classes.anonymousDonationForm}>
      <Group align="top" wrap="nowrap">
        <Checkbox
          label={null}
          id="anonymous_donation_checkbox"
          {...form.getInputProps('anonymous', { type: 'checkbox' })}
        />
        <Stack gap={4}>
          <Text fz="sm" fw={600}>
            Make my donation anonymously
          </Text>
          <Text fz="xs" c="gray">{`Your personal information will not be shared with ${
            storeName ?? 'your cause'
          }`}</Text>
        </Stack>
      </Group>
    </Card>
  );
};

export { AnonymousDonationForm };
